import React, { useEffect } from 'react'
import styled from 'styled-components'
//import PropTypes from 'prop-types'

const MediaWrap = styled.div`
  width: 520px;
  display: flex; /* 横並び */
  flex-wrap: wrap;
  margin: 4px;
  box-shadow: 0 0 3px 2px 'rgba(0,0,0,0.4)';
  background-color: #649CDF;
  color: #fff;
  font-size: 14px;
  font-weight: bold;

  text-align: center;
  align-items: center;
`
const MediaItem = styled.div`
  display: flex; /* 縦並び */
  flex-direction: column;
  height: 40px;
  border-right: 2px dashed #fff;
`

const HealthTitle = styled.div`
  margin: auto;
  text-overflow: ellipsis; /* 見切れ対策 */
  overflow: hidden;
  white-space: nowrap;
` 

const MediaHeaderActivityEmissions = (props) => {
  const {
  } = props

  // 初期値
  useEffect(() => {
  })

  return (
    <MediaWrap>
      <MediaItem>
        <HealthTitle style={{width:'200px'}}>項目</HealthTitle>
      </MediaItem>
      <MediaItem>
        <HealthTitle style={{width:'150px'}}>使用量</HealthTitle>
      </MediaItem>
      <MediaItem>
        <HealthTitle style={{width:'150px'}}>CO2（ton）</HealthTitle>
      </MediaItem>
    </MediaWrap>
  )
}

MediaHeaderActivityEmissions.propTypes = {
}

export default MediaHeaderActivityEmissions
